export default __webpack_public_path__ + "static/dataunions@2x-339c00cac0dab12095ca0c7b6bc57312.png";